var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-image',{staticClass:"bj",attrs:{"fit":"cover","src":_vm.bgUrl}}),_c('img',{staticClass:"btn",attrs:{"src":_vm.btnUrl,"alt":""},on:{"click":_vm.openApplet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }